// extracted by mini-css-extract-plugin
export default {"tableWrapper":"basic-table__tableWrapper","noDataWrapper":"basic-table__noDataWrapper","basicForm":"basic-table__basicForm"};